import AWS from 'aws-sdk'

export default class AWSManager {
  static uploadFile(key: string, content: File) {
    return new Promise((resolve, reject) => {
      AWS.config.update({
        region: 'eu-central-1',
        credentials: new AWS.CognitoIdentityCredentials({
          IdentityPoolId: 'eu-central-1:d9454d97-6fc1-4dd8-80ad-65d7d2e257fb'
        })
      })

      // Use S3 ManagedUpload class as it supports multipart uploads
      const upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: 'findoo',
          Key: key,
          Body: content
        }
      }).promise()

      upload.then(
        data => {
          resolve(data.Location)
        },
        err => {
          reject(err)
        }
      )
    })
  }

  static async getPresignedUrl(key: string) {
    AWS.config.update({
      region: 'eu-central-1',
      credentials: new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'eu-central-1:d9454d97-6fc1-4dd8-80ad-65d7d2e257fb'
      })
    })
    const s3 = new AWS.S3({
      apiVersion: '2006-03-01',
      region: 'eu-central-1'
    })

    try {
      const signedUrl = await s3.getSignedUrlPromise('getObject', {
        Bucket: 'findoo',
        Key: key
      })
      return signedUrl
    } catch (error) {
      return undefined
    }
  }
}
